var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var LoginFlowPresenter = /** @class */ (function () {
    function LoginFlowPresenter(usecase, actions, mobAppCodeStreamUseCase) {
        this.usecase = usecase;
        this.actions = actions;
        this.mobAppCodeStreamUseCase = mobAppCodeStreamUseCase;
        this.resetLoginState = false;
    }
    LoginFlowPresenter.prototype.totpValidateOtp = function (req) {
        var _this = this;
        this.actions.clientValOTP.hideError();
        this.actions.clientValOTP.loader();
        this.usecase.totpValidateOtp.execute({
            onSuccess: function (data) {
                var _a, _b;
                _this.actions.clientValOTP.clientValidateOTP(data);
                _this.actions.updateAccountDetails.updateAccountDetails({
                    accTyp: data.accData.accTyp,
                    userID: data.userID || data.accData.userID,
                    emaildId: data.emaildId,
                    accountCode: data.accountCode,
                    lgnSrc: data.lgnSrc,
                    userName: data === null || data === void 0 ? void 0 : data.userName,
                    isImpersonated: data.isImpersonated,
                    empOrDependent: (_b = (_a = data === null || data === void 0 ? void 0 : data.accData) === null || _a === void 0 ? void 0 : _a.accs) === null || _b === void 0 ? void 0 : _b.empOrDependent,
                    productsAlias: data === null || data === void 0 ? void 0 : data.productsAlias,
                    prefAccTyp: data === null || data === void 0 ? void 0 : data.prefAccTyp,
                });
                localStorage.setItem("accountCode", data.accountCode);
                localStorage.setItem("acc_data", JSON.stringify(data.accData));
                _this.actions.clientValOTP.stopLoader();
                _this.actions.clientValOTP.setError({ isOpen: false, error: undefined });
            },
            onError: function (error) {
                _this.actions.clientValOTP.setError({ isOpen: true, error: error });
                _this.actions.clientValOTP.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.totpGenerateOtp = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.totpGenerateOtp.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginFlowPresenter.prototype.updateResetLoginState = function (resetLoginState) {
        this.resetLoginState = resetLoginState;
    };
    LoginFlowPresenter.prototype.getReturnLoginState = function () {
        return this.resetLoginState;
    };
    LoginFlowPresenter.prototype.getUnblockUserDetails = function (req) {
        var _this = this;
        this.actions.unblockUser.hideError();
        this.actions.unblockUser.loader();
        this.usecase.unblockUser.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.unblockUser.unblockUser({
                        success: data.success,
                        userID: req.userId,
                    });
                }
                _this.actions.unblockUser.stopLoader();
            },
            onError: function (error) {
                _this.actions.unblockUser.setError({ isOpen: true, error: error });
                _this.actions.unblockUser.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.flushLoginError = function () {
        this.updateResetLoginState(false);
        this.actions.clientLoginDataActions.hideError();
        this.actions.guestRegisterActions.hideError();
        this.actions.clientGenOTP.hideError();
        this.actions.guestValidateMPIN.hideError();
        this.actions.clientValPass.hideError();
        this.actions.getAccountDetails.hideError();
        this.actions.clientForgotUserID.hideError();
        this.actions.unblockUser.hideError();
        this.actions.clientSetPass.hideError();
        this.actions.clientValOTP.hideError();
        this.actions.guestRegEmailVerifyOTP.hideError();
    };
    LoginFlowPresenter.prototype.flushLoginReducers = function () {
        this.actions.clientSetPass.ClientSetPassword({});
    };
    LoginFlowPresenter.prototype.updateLoginData = function (data) {
        this.actions.clientLoginDataActions.getLoginData({
            jwtToken: data === null || data === void 0 ? void 0 : data.jwtToken,
            accTyp: data === null || data === void 0 ? void 0 : data.accTyp,
            userID: data === null || data === void 0 ? void 0 : data.userID,
            emaildId: data === null || data === void 0 ? void 0 : data.emaildId,
            accountCode: data === null || data === void 0 ? void 0 : data.accountCode,
            lgnSrc: data === null || data === void 0 ? void 0 : data.lgnSrc,
            isImpersonated: data === null || data === void 0 ? void 0 : data.isImpersonated,
            //
            registeredGuestAccount: data === null || data === void 0 ? void 0 : data.registeredGuestAccount,
            clientAccount: data === null || data === void 0 ? void 0 : data.clientAccount,
            accValDays: data === null || data === void 0 ? void 0 : data.accValDays,
            name: data === null || data === void 0 ? void 0 : data.name,
            mobile: data === null || data === void 0 ? void 0 : data.mobile,
            status: data === null || data === void 0 ? void 0 : data.status,
            message: data === null || data === void 0 ? void 0 : data.message,
            registeredDate: data === null || data === void 0 ? void 0 : data.registeredDate,
            pan: data === null || data === void 0 ? void 0 : data.pan,
            accountTypesArray: data === null || data === void 0 ? void 0 : data.accountTypesArray,
            vendorSource: data === null || data === void 0 ? void 0 : data.vendorSource,
            isOtpSucesss: data === null || data === void 0 ? void 0 : data.isOtpSucesss,
            loginFlow: data === null || data === void 0 ? void 0 : data.loginFlow,
            passwordReset: data === null || data === void 0 ? void 0 : data.passwordReset,
            daysLeft: data === null || data === void 0 ? void 0 : data.daysLeft,
            totpSetting: data === null || data === void 0 ? void 0 : data.totpSetting,
        });
    };
    LoginFlowPresenter.prototype.flushClientVerifyPassword = function () {
        this.actions.clientValPass.ClientValPassword({});
        this.actions.clientValPass.hideError();
    };
    LoginFlowPresenter.prototype.flushLoginData = function (showPopup) {
        this.actions.clientLoginDataActions.getLoginData({
            jwtToken: "",
            accTyp: "",
            userID: "",
            emaildId: "",
            accountCode: "",
            lgnSrc: "",
            isImpersonated: false,
            //
            registeredGuestAccount: false,
            clientAccount: false,
            accValDays: 0,
            name: "",
            mobile: "",
            status: "",
            message: "",
            registeredDate: "",
            accountTypesArray: [],
            vendorSource: "",
            isOtpSucesss: false,
            loginFlow: "",
            passwordReset: false,
            totpSetting: undefined,
        });
        showPopup && this.actions.clientValOTP.setShowLoginPopup(showPopup);
        this.actions.getAccountDetails.getAccountDetails({
            registeredGuestAccount: false,
            clientAccount: false,
            status: false,
            guestId: "",
            mobile: "",
        });
        this.actions.clientValPass.ClientValPassword({
            isOtpSucesss: false,
            loginFlow: "",
            message: "",
            status: false,
        });
        this.actions.guestValidateMPIN.GuestValidateMPIN({
            status: false,
            daysLeft: 0,
            userType: "",
            guestId: "",
            message: "",
            registeredDate: "",
        });
        this.actions.updateAccountDetails.updateAccountDetails({
            accTyp: "",
            userID: "",
            emaildId: "",
            accountCode: "",
            lgnSrc: "",
            isImpersonated: false,
            userName: "",
            empOrDependent: "",
            productsAlias: [],
            prefAccTyp: "",
        });
        this.actions.clientValPass.ClientValPassword({
            isOtpSucesss: false,
            loginFlow: "",
            message: "",
            status: false,
        });
        this.actions.clientGenOTP.ClientGenOTP({
            message: "",
            OTPSent: false,
        });
    };
    LoginFlowPresenter.prototype.flushForgotUserIdData = function () {
        this.actions.clientForgotUserID.hideError();
        this.actions.clientForgotUserID.forgotUserID({
            message: "",
            success: false,
        });
    };
    LoginFlowPresenter.prototype.flushLoginFlowData = function () {
        this.actions.clientLoginDataActions.hideError();
        this.actions.guestRegisterActions.hideError();
        this.actions.clientGenOTP.hideError();
        this.actions.guestValidateMPIN.hideError();
        this.actions.clientValPass.hideError();
        this.actions.getAccountDetails.hideError();
        this.actions.clientForgotUserID.hideError();
        this.actions.unblockUser.hideError();
        this.actions.clientSetPass.hideError();
        this.actions.clientValOTP.hideError();
        this.actions.guestRegEmailVerifyOTP.hideError();
        this.actions.clientValPass.ClientValPassword({
            isOtpSucesss: false,
            loginFlow: "",
            message: "",
            status: false,
        });
        this.actions.guestValidateMPIN.GuestValidateMPIN({
            status: false,
            daysLeft: 0,
            userType: "",
            guestId: "",
            message: "",
            registeredDate: "",
        });
        this.actions.clientValPass.ClientValPassword({
            isOtpSucesss: false,
            loginFlow: "",
            message: "",
            status: false,
        });
        this.actions.clientGenOTP.ClientGenOTP({
            message: "",
            OTPSent: false,
        });
    };
    LoginFlowPresenter.prototype.flushOtpData = function () {
        this.actions.clientGenOTP.ClientGenOTP({
            message: "",
            OTPSent: false,
        });
    };
    LoginFlowPresenter.prototype.getImage = function (req) {
        var _this = this;
        this.actions.clientLoginDataActions.hideError();
        this.actions.clientLoginDataActions.loader();
        this.usecase.imageClientLoginFlow.execute({
            onSuccess: function (data) {
                _this.flushLoginData();
                _this.updateLoginData({
                    userID: req.userId,
                    accountTypesArray: data.accountTypesArray,
                    message: data.message,
                    status: data.status,
                    vendorSource: data.vendorSource,
                    loginFlow: data.loginFlow,
                    totpSetting: data.totpSetting,
                });
                _this.actions.clientLoginDataActions.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientLoginDataActions.setError({ isOpen: true, error: error });
                _this.actions.clientLoginDataActions.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.getQuestionsData = function (req) {
        var _this = this;
        this.actions.clientValPass.hideError();
        this.actions.clientValPass.loader();
        this.usecase.clientLoginFlowQuestion.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.clientValPass.ClientValPassword(data);
                }
                _this.actions.clientValPass.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientValPass.setError({ isOpen: true, error: error });
                _this.actions.clientValPass.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.updateLoginPopup = function (loginPopup) {
        this.actions.clientValOTP.setShowLoginPopup(loginPopup);
    };
    LoginFlowPresenter.prototype.getLoginData = function (req) {
        var _this = this;
        this.actions.clientValOTP.hideError();
        this.actions.clientValOTP.loader();
        this.usecase.clientLoginData.execute({
            onSuccess: function (data) {
                var _a, _b;
                _this.actions.clientValOTP.clientValidateOTP(data);
                _this.actions.updateAccountDetails.updateAccountDetails({
                    accTyp: data.accData.accTyp,
                    userID: data.userID || data.accData.userID,
                    emaildId: data.emaildId,
                    accountCode: data.accountCode,
                    lgnSrc: data.lgnSrc,
                    userName: data === null || data === void 0 ? void 0 : data.userName,
                    isImpersonated: data.isImpersonated,
                    empOrDependent: (_b = (_a = data === null || data === void 0 ? void 0 : data.accData) === null || _a === void 0 ? void 0 : _a.accs) === null || _b === void 0 ? void 0 : _b.empOrDependent,
                    productsAlias: data === null || data === void 0 ? void 0 : data.productsAlias,
                    prefAccTyp: data === null || data === void 0 ? void 0 : data.prefAccTyp,
                });
                localStorage.setItem("accountCode", data.accountCode);
                localStorage.setItem("acc_data", JSON.stringify(data.accData));
                _this.actions.clientValOTP.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientValOTP.setError({ isOpen: true, error: error });
                _this.actions.clientValOTP.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.guestRegister = function (req) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.usecase.guestRegisterAddAccount.execute({
                onSuccess: function (data) {
                    resolve(data);
                },
                onError: function (error) {
                    reject(error);
                },
            }, req);
        });
    };
    LoginFlowPresenter.prototype.clientSetPassword = function (req) {
        var _this = this;
        this.actions.clientSetPass.hideError();
        this.actions.clientSetPass.loader();
        this.usecase.clientSetPassword.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.clientSetPass.ClientSetPassword(data);
                }
                _this.actions.clientSetPass.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientSetPass.setError({ isOpen: true, error: error });
                _this.actions.clientSetPass.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.clientValidateOTP = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = null;
                        return [4 /*yield*/, this.usecase.clientValidateOTP.execute({
                                onSuccess: function (data) {
                                    response = data;
                                },
                                onError: function (error) { },
                            }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LoginFlowPresenter.prototype.clientGenerateOTP = function (req) {
        var _this = this;
        this.actions.clientGenOTP.hideError();
        this.actions.clientGenOTP.loader();
        this.usecase.clientGenerateOTP.execute({
            onSuccess: function (data) {
                _this.actions.clientGenOTP.ClientGenOTP(data);
                _this.actions.clientGenOTP.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientGenOTP.setError({ isOpen: true, error: error });
                _this.actions.clientGenOTP.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.clientForgotUserID = function (req) {
        var _this = this;
        this.actions.clientForgotUserID.hideError();
        this.actions.clientForgotUserID.loader();
        this.usecase.clientForgotUserID.execute({
            onSuccess: function (data) {
                _this.actions.clientForgotUserID.forgotUserID(data);
                _this.actions.clientForgotUserID.stopLoader();
            },
            onError: function (error) {
                _this.actions.clientForgotUserID.setError({ isOpen: true, error: error });
                _this.actions.clientForgotUserID.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.getAccountDetails = function (req) {
        var _this = this;
        this.actions.getAccountDetails.hideError();
        this.actions.getAccountDetails.getAccountDetailloader();
        this.usecase.getAccountDetails.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.getAccountDetails.getAccountDetails({
                        registeredGuestAccount: data.registeredGuestAccount,
                        clientAccount: data.clientAccount,
                        status: data.status,
                        guestId: data.guestId,
                        mobile: req.mob,
                    });
                }
                _this.actions.getAccountDetails.getAccountDetailStopLoader();
            },
            onError: function (error) {
                _this.actions.getAccountDetails.setError({ isOpen: true, error: error });
                _this.actions.getAccountDetails.getAccountDetailStopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.guestLoginSetMPIN = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.guestLoginSetMpin.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LoginFlowPresenter.prototype.guestForgotSetMPIN = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.usecase.guestForgotSetMpin.execute({
                            onSuccess: function (data) {
                                resolve(data);
                            },
                            onError: function (error) {
                                reject(error);
                            },
                        }, req);
                    })];
            });
        });
    };
    LoginFlowPresenter.prototype.GuestValidateMPIN = function (req) {
        var _this = this;
        this.actions.guestValidateMPIN.hideError();
        this.actions.guestValidateMPIN.GuestValidateMPINloader();
        this.usecase.guestValidateMPIN.execute({
            onSuccess: function (data) {
                if (data) {
                    _this.actions.guestValidateMPIN.GuestValidateMPIN(data);
                    localStorage.setItem("guest_acc_data", JSON.stringify(data));
                }
                _this.actions.guestValidateMPIN.GuestValidateMPINStopLoader();
            },
            onError: function (error) {
                _this.actions.guestValidateMPIN.setError({ isOpen: true, error: error });
                _this.actions.guestValidateMPIN.GuestValidateMPINStopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.guestForgotPIN = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = null;
                        return [4 /*yield*/, this.usecase.guestForgotPIN.execute({
                                onSuccess: function (data) {
                                    response = data;
                                },
                                onError: function (error) { },
                            }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LoginFlowPresenter.prototype.guestRegValidateOTP = function (req) {
        var _this = this;
        this.actions.guestRegisterActions.hideError();
        this.actions.guestRegisterActions.loader();
        this.usecase.guestValidate.execute({
            onSuccess: function (data) {
                _this.actions.guestRegisterActions.guestRegister(data);
                _this.actions.guestRegisterActions.stopLoader();
            },
            onError: function (error) {
                _this.actions.guestRegisterActions.setError({ isOpen: true, error: error });
                _this.actions.guestRegisterActions.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.checkNAddEmail = function (req) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        response = null;
                        return [4 /*yield*/, this.usecase.checkNAddEmailUseCase.execute({
                                onSuccess: function (data) {
                                    response = data;
                                },
                                onError: function (error) {
                                    response = {
                                        message: error.getErrorMessageOrErrMsg(),
                                        status: false,
                                    };
                                },
                            }, req)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    LoginFlowPresenter.prototype.guestRegEmailVerifyOTP = function (req) {
        var _this = this;
        this.actions.guestRegEmailVerifyOTP.hideError();
        this.actions.guestRegEmailVerifyOTP.loader();
        this.usecase.guestRegEmailVerifyOTP.execute({
            onSuccess: function (data) {
                _this.actions.guestRegEmailVerifyOTP.GuestVerifyEmailOTP({
                    message: data.message,
                    uniqueID: req.unId,
                    emailOTPValidated: data.emailOTPValidated,
                    isClient: data.isClient,
                    isGuest: data.isGuest,
                });
                _this.actions.guestRegEmailVerifyOTP.stopLoader();
            },
            onError: function (error) {
                _this.actions.guestRegEmailVerifyOTP.setError({ isOpen: true, error: error });
                _this.actions.guestRegEmailVerifyOTP.stopLoader();
            },
        }, req);
    };
    LoginFlowPresenter.prototype.mobAppCodeStream = function (userId, userType) {
        this.mobAppCodeStreamUseCase.streamQuote(userId, userType);
    };
    return LoginFlowPresenter;
}());
export default LoginFlowPresenter;
